import React from 'react'
import { Typography, IconButton, Tooltip, Box } from '@mui/material'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import Card from '../../../components/Card'

const ProfitCard = ({
  name,
  value,
  infoText,
  color = '#1976d2',
  icon,
  iconBg = 'rgba(21, 167, 71, 0.12)',
  iconColor = '#157f3c',
}) => {
  return (
    <Card padding="1rem" overflow="hidden">
      <div className="d-flex justify-content-end">
        {infoText && (
          <Tooltip title={infoText} arrow placement="top">
            <IconButton
              size="small"
              sx={{
                color: '#d19985',
                '&:hover': { color: color },
                padding: 0
              }}
            >
              <InfoOutlinedIcon fontSize="small" sx={{ color: '#5c6773' }} />
            </IconButton>
          </Tooltip>
        )}
      </div>
      <div className="d-flex justify-content-between align-items-start">
        <div className="d-flex align-items-center" style={{ gap: 12 }}>
          <Box
            sx={{
              width: 56,
              height: 56,
              borderRadius: 2,
              backgroundColor: iconBg,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flex: '0 0 56px',
            }}
          >
            <Box sx={{ color: iconColor, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              {React.isValidElement(icon) ? (
                icon
              ) : (
                <img src={icon} alt="icon" style={{ width: '24px', height: '24px' }} />
              )}
            </Box>
          </Box>

          <div>
            <Typography
              variant="subtitle1"
              sx={{
                mb: 0.5,
                color: '#5c6773',
                fontWeight: 600,
              }}
            >
              {name}
            </Typography>
            <Typography variant="h5" sx={{ fontWeight: 800, color: '#3b454f' }}>
              {value}
            </Typography>
          </div>
        </div>

      </div>
    </Card>
  )
}

export default ProfitCard